import { render, staticRenderFns } from "./UserResponsabilityInfoCard.vue?vue&type=template&id=fe780ce8"
import script from "./UserResponsabilityInfoCard.vue?vue&type=script&lang=js"
export * from "./UserResponsabilityInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports